import React from "react";
import CsLineIcons from '../../cs-line-icons';

const formatRelativeTime = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";

    const diff = Date.now() - date.getTime();
    const minute = 60 * 1000;
    const hour = 60 * minute;
    const day = 24 * hour;

    if (diff < minute) return "now";
    if (diff < hour) return `${Math.floor(diff / minute)} min ago`;
    if (diff < day) return `${Math.floor(diff / hour)} hr ago`;
    return `${Math.floor(diff / day)} days ago`;
};

const styleClass = (style) => {
    switch (style) {
        case "UR":
            return "is-urgent";
        case "LO":
            return "is-low";
        case "3D":
            return "is-activity";
        default:
            return "is-default";
    }
};

class Item extends React.Component {
    onRead = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.props.onRead(this.props.id);
    };

    render() {
        return (
            <li className="notification-item">
                <div className={`notification-item-icon ${styleClass(this.props.style)}`}>
                    <span className="notification-item-dot" />
                    <CsLineIcons icon="form-check" size="16" />
                </div>
                <div className="notification-item-copy">
                    {this.props.title ? <div className="notification-item-title">{this.props.title}</div> : null}
                    <div className="notification-item-description">{this.props.description}</div>
                </div>
                <div className="notification-item-meta">
                    <span>{formatRelativeTime(this.props.activeDate)}</span>
                    <button type="button" onClick={this.onRead}>set as read</button>
                </div>
            </li>
        );
    }
}

export default Item;
